module.exports = __webpack_public_path__ + "static/media/wax2.32d7b3c9.jpg";